// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  GUEST: '/info/publics',
};


// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgotPassword`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    products: {
      new: `${ROOTS.DASHBOARD}/productos/new`,
      list: `${ROOTS.DASHBOARD}/productos`,
      edit: `${ROOTS.DASHBOARD}/productos/edit`
    },
    combos: {
      new: `${ROOTS.DASHBOARD}/productos/combos/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/productos/combos/${id}/edit`,
    },
    settingFel: {
      new: `${ROOTS.DASHBOARD}/configuracionFel/new`,
      list: `${ROOTS.DASHBOARD}/configuracionFel`,
    },
    history: {
      list: `${ROOTS.DASHBOARD}/historico`,
    },
    dashboards: {
      ventas: `${ROOTS.DASHBOARD}/EstadisticasVentas`,
      comparativos: `${ROOTS.DASHBOARD}/Comparativos`,
    },
    reportes: {
      ventas: `${ROOTS.DASHBOARD}/ReporteVentas`,
    },
    inventario: {
      pronostico: `${ROOTS.DASHBOARD}/IngredientesPorProducto`,
      pronosticoProductos: `${ROOTS.DASHBOARD}/PronosticoInventario`,
    },
    cocina: {
      list: `${ROOTS.DASHBOARD}/cocina`,
    },
    cashbox: {
      list: `${ROOTS.DASHBOARD}/cajas`,
    },
    clients: {
      list: `${ROOTS.DASHBOARD}/clientes`,
    },
    traslados: {
      list: `${ROOTS.DASHBOARD}/traslados`,
      new: `${ROOTS.DASHBOARD}/traslados/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/traslados/${id}/edit`,
    },
    compras: {
      list: `${ROOTS.DASHBOARD}/compras`,
      new: `${ROOTS.DASHBOARD}/compras/new`,
    },
    proveedores: {
      list: `${ROOTS.DASHBOARD}/proveedores`,
    },
    cashiers: {
      new: `${ROOTS.DASHBOARD}/cajeros/new`,
      list: `${ROOTS.DASHBOARD}/cajeros`,
    },
    categories: {
      new: `${ROOTS.DASHBOARD}/categorias/new`,
      list: `${ROOTS.DASHBOARD}/categorias`,
    },
    attributes: {
      new: `${ROOTS.DASHBOARD}/atributos/new`,
      list: `${ROOTS.DASHBOARD}/atributos`,
    },
    printers: {
      new: `${ROOTS.DASHBOARD}/impresoras/new`,
      list: `${ROOTS.DASHBOARD}/impresoras`,
    },
    care: {
      pacientes: {
        list: `${ROOTS.DASHBOARD}/pacientes`,
        new: `${ROOTS.DASHBOARD}/pacientes/new`,
        edit: `${ROOTS.DASHBOARD}/pacientes/edit`,
        expedient: `${ROOTS.DASHBOARD}/pacientes/expedient`
      },
      citas: {
        list: `${ROOTS.DASHBOARD}/citas`,
        edit: `${ROOTS.DASHBOARD}/citas/edit`
      },
      tipoCitas: {
        list: `${ROOTS.DASHBOARD}/tipoCitas`,
        new: `${ROOTS.DASHBOARD}/tipoCitas/new`
      }
    },
    fel: {
      list: `${ROOTS.DASHBOARD}/fel`,
      new: `${ROOTS.DASHBOARD}/fel/new`
    },
    autogestion: {
      mesas: {
        list: `${ROOTS.DASHBOARD}/autogestion/mesas`,
        new: `${ROOTS.DASHBOARD}/autogestion/mesas/new`
      }
    }
  },
  // GUEST
  publics: {
    terminos: `${ROOTS.GUEST}/terms-and-conditions`,
    privacidad: `${ROOTS.GUEST}/privacy-policy`,
    edocuments: `${ROOTS.GUEST}/documents`,
    tutoriales: `${ROOTS.GUEST}/tutoriales`
  },
};
